import type { Locales } from './locales';

function createTranslations({
  locales,
  lang = 'vi',
}: {
  locales: Locales;
  lang: keyof Locales;
}) {
  return function translate(key: keyof Locales[typeof lang]) {
    return locales[lang][key] || key;
  };
}

export default createTranslations;
